/*
 * @Description: 
 * @Author: jiangdongdong@mininglamp.com
 * @Date: 2025-05-19 10:13:33
 */
import { request } from './request';
export function apiSession() {
    return request({
      method: 'GET',
      url: `/api_v2/session`
    });
  }
export function apiOauth() {
  return request({
    method: 'GET',
    url: `/api_v2/oauth`
  });
}
export function refreshToken() {
  const refreshToken = localStorage.getItem('refresh_token') ||''
  const values = {
    refresh_token: refreshToken
  }
  return request({
    method: 'POST',
    url:'/api_v2/refreshToken',
    data: values
  });
}